export function translateErrorMessage(msg: string): string {
    if (!msg) {
        return msg;
    }

    const normalizedMsg = msg.replace('GraphQL error: ', '');
    const messageParts = normalizedMsg.split('::');
    if (messageParts.length > 1) {
        const code = messageParts[0];
        const details = messageParts.slice(1).join('::').trim();

        if (
            code === 'INPUT_FAILED_VALIDATION' &&
            /^Channel group\s+".*"\s+already exists\.?$/i.test(details)
        ) {
            return 'A channel group with this name already exists. Please choose a different name.';
        }

        return details;
    }

    if (msg.toLowerCase().includes('network error:')) {
        return 'Cannot connect to server';
    }

    if (msg.includes('ECONNREFUSED')) {
        return 'Cannot connect to database';
    }

    if (msg.includes('ENOTFOUND')) {
        return 'Cannot connect to database';
    }

    if (msg.includes('duplicate key error collection')) {
        return 'Cannot insert item due to name duplication';
    }

    return normalizedMsg;
}

export const parseGraphQlError = (error: Error) => {
    const parts = error.message.replace('GraphQL error: ', '').split('::');
    const messageOnly = parts.length === 1;

    return {
        code: messageOnly ? undefined : parts[0],
        message: messageOnly ? parts[0] : parts[1],
    };
};

export const trialPeriodMsg = 'Trial period has expired';
